module.exports = __webpack_public_path__ + "static/img/3bg_9.1ecd16f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_9.png
// module id = 702
// module chunks = 1